/**
 * Base api path
 *
 * @type {string}
 */

const permission = {
    LOGIN: 1,
    ADMIN: 2,
    STUDY: 3,
    CLIENT: 4,

}

export default Object.freeze(permission)